import { Injectable } from '@angular/core';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

@Injectable({ providedIn: 'root' })
export class MarkdownRendererService {
  private sequence = 0;

  constructor() {
    marked.use({
      gfm: true,
      breaks: true,
    });
  }

  render(markdown: string): string {
    const html = marked.parse(markdown, {
      gfm: true,
      breaks: true,
    }) as string;

    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      ADD_TAGS: ['input'],
      ADD_ATTR: ['align', 'checked', 'class', 'disabled', 'start', 'type'],
    });
  }

  async renderMermaidBlocks(host: HTMLElement): Promise<void> {
    const codeBlocks = Array.from(host.querySelectorAll<HTMLElement>('pre > code.language-mermaid'));
    if (codeBlocks.length === 0) {
      return;
    }

    const { default: mermaid } = await import('mermaid');
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: 'strict',
      flowchart: { useMaxWidth: true },
    });

    for (const [index, codeBlock] of codeBlocks.entries()) {
      const source = codeBlock.textContent?.trim() ?? '';
      const pre = codeBlock.parentElement;
      if (!source || !pre) {
        continue;
      }

      const placeholder = document.createElement('div');
      placeholder.className = 'markdown-mermaid';
      const renderId = `markdown-mermaid-${++this.sequence}-${index}`;

      try {
        const { svg } = await mermaid.render(renderId, source);
        placeholder.innerHTML = svg;
      } catch (error: unknown) {
        placeholder.classList.add('markdown-mermaid-error');
        placeholder.textContent = `Mermaid 圖表無法解析：${this.errorMessage(error)}`;
      }

      pre.replaceWith(placeholder);
    }
  }

  private errorMessage(error: unknown): string {
    return error instanceof Error ? error.message : '未知錯誤';
  }
}
